import React, { useState, useEffect } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
// import { addLike, getLikes } from "../../../../contentful/CMS.js";
import { formatImageAlt } from "../../../shared/utils/stringUtilities.js";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import ShareModal from "../../molecules/share-modal/shareModal";
import ConversationUpper from "../../atoms/conversation-upper/conversationUpper";
import ConversationBottom from "../../atoms/conversation-bottom/conversationBottom";

import "./headboardConversation.scss";

const HeadboardConversation = (props: ReferenciaCabecera) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [voted, setVoted] = useState(false);
  const [scrollY, setScrollY] = useState<any>(0);
  const { contentful_id } = props[0];
  const { isBrowser, localStorage, window, document } = useBrowserMode();

  const handleScrollY = () => setScrollY(window.scrollY);

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  const makeVote = async () => {
    setVoted(true);
    // const res = await getLikes(contentful_id);
    // await addLike(contentful_id, res);

    isBrowser &&
      localStorage.setItem(
        `comfama:likedPodcastOrEpisode.${contentful_id}`,
        "true"
      );
  };

  const widthHandler = () => {
    const width = window.innerWidth;
    const footer = document.getElementById("footer");

    if (width < 960) {
      if (footer !== null) footer.style.paddingBottom = "70px";
    } else {
      if (footer !== null) footer.style.paddingBottom = "0px";
    }
  };

  const handleScroll = () => {
    if (document !== null) {
      document
        .getElementById("make-comment")
        .scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
    }
  };

  useEffect(() => window.addEventListener("scroll", handleScrollY));
  useEffect(() => window.addEventListener("resize", widthHandler));

  return (
    <div className="o-headboard-conversation">
      {parseInt(scrollY) >= 380 ? (
        <div className="hide-on-mobile">
          <ConversationUpper
            liked={voted}
            makeLike={makeVote}
            onClickBtn={handleScroll}
            shareAction={toggleModal}
          />
        </div>
      ) : null}

      <div className="o-headboard-conversation__bread hide-on-mobile">
        <Breadcrumb content={props[0].migaDePan} />
      </div>

      <div className="o-headboard-conversation__container">
        <div className="o-headboard-conversation__container-info">
          <h1 className="o-headboard-conversation__container-info__title">
            {props[0].tituloPrincipal}
          </h1>

          <p className="o-headboard-conversation__container-info__date">
            12 Junio 2020
          </p>

          <div className="o-headboard-conversation__container-info__description">
            {documentToReactComponents(props[0].descripcion.json)}
          </div>

          <div className="o-headboard-conversation__container-info__profile">
            <div className="o-headboard-conversation__container-info__profile-name">
              <p>{props[0].referenciaTags[0].nombreTag}</p>
            </div>

            <div className="o-headboard-conversation__container-info__profile-img">
              <img
                src={props[0].imagenHeader.file.url}
                alt={formatImageAlt(props[0].imagenHeader.title)}
              />
            </div>
          </div>

          <div className="o-headboard-conversation__container-info__icons">
            <div
              className="o-headboard-conversation__container-info__icons-like"
              onClick={makeVote}
            >
              <p
                className={`like-icon ${
                  !voted ? "icon-thumbs-up" : "icon-thumbs-up1"
                }`}
              ></p>
              <p className="like hide-on-mobile">
                {!voted ? props[0].like : props[0].like + 1}
              </p>
            </div>

            <div className="o-headboard-conversation__container-info__icons-separator"></div>

            <div
              className="o-headboard-conversation__container-info__icons-share"
              onClick={toggleModal}
            >
              <p className="icon-share share-icon"></p>
              <p className="share hide-on-mobile">{props[0].botonCompartir}</p>
            </div>
          </div>
        </div>

        <div className="o-headboard-conversation__container-img">
          <img
            src={props[0].imagenHeader.file.url}
            alt={formatImageAlt(props[0].imagenHeader.title)}
          />
        </div>
      </div>

      <div className="show-on-mobile">
        {parseInt(scrollY) >= 400 ? (
          <ConversationBottom
            liked={voted}
            makeLike={makeVote}
            onClickBtn={handleScroll}
            shareAction={toggleModal}
            title={props[0].tituloPrincipal}
          />
        ) : null}
      </div>

      <ShareModal open={isModalVisible} onClose={toggleModal} href={""} />
    </div>
  );
};

export default HeadboardConversation;
